// Load FingerprintJS from the minified file
let FingerprintJS = null

async function loadFingerprintJS() {
  if (FingerprintJS) return FingerprintJS

  // Check if already loaded globally
  if (window.FingerprintJS) {
    FingerprintJS = window.FingerprintJS
    return FingerprintJS
  }

  // Load the script dynamically
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = '/fingerprint.min.js'
    script.onload = () => {
      FingerprintJS = window.FingerprintJS
      resolve(FingerprintJS)
    }
    script.onerror = () => reject(new Error('Failed to load FingerprintJS'))
    document.head.appendChild(script)
  })
}

const COOKIE_NAME = 'widget_user_id'
const COOKIE_EXPIRY_DAYS = 365

/**
 * Get or set a cookie
 */
function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}

function setCookie(name, value, days) {
  const date = new Date()
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
  const expires = `expires=${date.toUTCString()}`
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`
}

/**
 * Generate a random UUID v4
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * Get or generate user fingerprint
 * Returns existing cookie value if present, otherwise generates new fingerprint
 */
export async function getUserFingerprint() {
  // Check if cookie exists
  const existingId = getCookie(COOKIE_NAME)
  if (existingId) {
    return existingId
  }

  // Try to get fingerprint
  let userId
  try {
    const fpLib = await loadFingerprintJS()
    const fp = await fpLib.load()
    const result = await fp.get()
    userId = result.visitorId
  } catch (error) {
    console.warn('Failed to get fingerprint, using UUID fallback:', error)
    userId = generateUUID()
  }

  // Store in cookie
  setCookie(COOKIE_NAME, userId, COOKIE_EXPIRY_DAYS)
  return userId
}
